import React, { useContext, useState } from 'react'

import PanelHeader from '../../../elem/panel/PanelHeader'
import { DataContext } from './DataContext'
import { DownArrow, UpArrow } from '../../../elem/Arrows'
import CollapseButton from '../../../elem/list/CollapseButton'
import SaveAsImageButton from '../../../elem/chart/SaveAsImageButton'
import { filterModes } from '../box-plot/FilterModeSelector'
import { AppStateContext } from '../AppStateContext'

// import { IconTooltup as Tooltip } from '../../../elem/Tooltip'

const PiperHeader = ({ chartRef }) => {
    const {
        isCollapsed,
        setCollapsed,
        displayFilterModeDropdown,
        setDisplayFilterModeDropdown,
        filterMode,
        loading,
    } = useContext(DataContext)
    const {
        mapState: { selectedFeatures },
    } = useContext(AppStateContext)

    return (
        <PanelHeader extraClass={'aggregatePanelHeader'}>
            <div className="panelHeaderText">Piper Diagram by Well Type</div>
            <div className="panelButtons">
                <SaveAsImageButton
                    name={`PiperDiagrambyWellType`}
                    componentRef={chartRef}
                    disabled={
                        loading ||
                        (!selectedFeatures.length &&
                            filterMode === filterModes[0])
                    }
                />
                <div
                    className="panelButton"
                    onClick={() =>
                        setDisplayFilterModeDropdown(!displayFilterModeDropdown)
                    }
                >
                    <span className="panelTimeOptionText">{filterMode}</span>
                    <span className="panelTimeOptionDropdown">
                        {displayFilterModeDropdown ? (
                            <UpArrow color={'white'} className={'is-white'} />
                        ) : (
                            <DownArrow color={'white'} className={'is-white'} />
                        )}
                    </span>
                </div>
                <CollapseButton
                    name={`piper`}
                    isCollapsed={isCollapsed}
                    setIsCollapsed={setCollapsed}
                />
            </div>
        </PanelHeader>
    )
}

export default PiperHeader
